import { render, staticRenderFns } from "./switchLang.vue?vue&type=template&id=0906ac35&"
import script from "./switchLang.vue?vue&type=script&lang=js&"
export * from "./switchLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports